import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { LanguageUrlSync } from "@/components/site/LanguageUrlSync";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LanguageUrlSync />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/service/:slug" element={<ServiceDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
